export default "__VITE_ASSET__DjXnDi6r__"